export const getGenreList = () => {
  return `
  query genreList($limit: Int, $offset: Int,$filters: DBFilterInput){
    values: genreList(
      limit: $limit,
      offset: $offset,
      filters: $filters
    ) {
      nameFr
      slug
      name
      nameEn
      id
      children {
        nameFr
        slug
        name
        nameEn
        id
        children {
          id
          nameFr
          slug
          name
          nameEn
          children {
            id
            nameFr
            slug
            name
            nameEn
            children {
              id
              nameFr
              name
              slug
              nameEn
            }
          }
        }
      }
      genre_parent{
        id
        nameFr
        slug
        nameEn
        name
      }
    }
  }`
}
